import { Alert, Button, FormControl, FormLabel, Heading, Input, Stack, Text } from '@chakra-ui/react';
import { Title } from '../../../atoms/Title';

export interface ForgotPasswordProps {
  errors: Array<string>;
  username: string;
  onUsernameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onForgotPasswordSubmit: (evt: React.FormEvent) => void;
  onLoginClick: () => void;
  isStudentApp?: boolean;
}

const ForgotPassword = (props: ForgotPasswordProps) => {
  const { errors, username, onUsernameChange, onForgotPasswordSubmit, isStudentApp } = props;

  const title = 'Reset password';

  return (
    <>
      <Title title={title} />

      <Heading as="h1" mb="6">
        {title}
      </Heading>

      <form onSubmit={onForgotPasswordSubmit}>
        <Text>
          To request a new password, enter your {isStudentApp ? <>email address</> : <>CAS&nbsp;Shield username</>}.
        </Text>

        {errors && errors.length > 0 && (
          <Alert status="error" mb="4">
            {[errors]}
          </Alert>
        )}

        <FormControl mb="6">
          <FormLabel fontSize="lg" htmlFor="username">
            {isStudentApp ? <>Email address</> : <>Username</>}
          </FormLabel>

          <Input
            id="username"
            autoComplete={isStudentApp ? 'email' : 'username'}
            type={isStudentApp ? 'email' : 'text'}
            size="lg"
            onChange={onUsernameChange}
            value={username}
            isRequired
            data-sentry-mask
          />
        </FormControl>

        <Stack spacing="3">
          <Button type="submit" size="lg" variant="solid" isDisabled={(username?.trim() ?? '') === ''}>
            Send reset password link
          </Button>

          <Button as="a" href="/" variant="ghost" size="lg">
            Return to login form
          </Button>
        </Stack>
      </form>
    </>
  );
};

export default ForgotPassword;
